// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "9c37e37aac32ad4a9934" + "/js/" + chunkId + ".js";
};